/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransportLotPlan } from './TransportLotPlan';
import {
    TransportLotPlanFromJSON,
    TransportLotPlanFromJSONTyped,
    TransportLotPlanToJSON,
} from './TransportLotPlan';

/**
 * 
 * @export
 * @interface TransportLotResponse
 */
export interface TransportLotResponse {
    /**
     * 
     * @type {Array<TransportLotPlan>}
     * @memberof TransportLotResponse
     */
    transportLotList: Array<TransportLotPlan>;
}

/**
 * Check if a given object implements the TransportLotResponse interface.
 */
export function instanceOfTransportLotResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "transportLotList" in value;

    return isInstance;
}

export function TransportLotResponseFromJSON(json: any): TransportLotResponse {
    return TransportLotResponseFromJSONTyped(json, false);
}

export function TransportLotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportLotResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transportLotList': ((json['transport_lot_list'] as Array<any>).map(TransportLotPlanFromJSON)),
    };
}

export function TransportLotResponseToJSON(value?: TransportLotResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transport_lot_list': ((value.transportLotList as Array<any>).map(TransportLotPlanToJSON)),
    };
}

